import { render } from "./BaselinesPage.vue?vue&type=template&id=5dc361da&scoped=true"
import script from "./BaselinesPage.vue?vue&type=script&lang=js"
export * from "./BaselinesPage.vue?vue&type=script&lang=js"

import "./BaselinesPage.vue?vue&type=style&index=0&id=5dc361da&lang=css"
import "./BaselinesPage.vue?vue&type=style&index=1&id=5dc361da&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc361da"]])

export default __exports__